import { render } from "./Privacy.vue?vue&type=template&id=5edf9ad2&scoped=true"
import script from "./Privacy.vue?vue&type=script&lang=js"
export * from "./Privacy.vue?vue&type=script&lang=js"

import "./custom-privacy.scss?vue&type=style&index=0&id=5edf9ad2&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5edf9ad2"]])

export default __exports__